import { updates } from '@/mocks/movies';

export default function Updates() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            被窝影院电影大全免费看的运营快讯与内容更新
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-3 md:left-[17px] top-2 bottom-2 w-0.5 bg-background-300/60"></div>

            <div className="space-y-8">
              {updates.map((item, i) => (
                <div key={item.id} className="relative">
                  <div className={`absolute -left-[22px] md:-left-[23px] top-1.5 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full border-2 border-background-50 ${
                    i === 0 ? 'bg-primary-500' : 'bg-background-300'
                  }`}></div>

                  <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70">
                    <span className="inline-block px-2.5 py-1 bg-accent-100 text-accent-800 text-xs font-medium rounded-md mb-2">
                      {item.date}
                    </span>
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-1.5">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}